import { Timestamp, TranslateFunction, WeekDays } from '@griply/types';

import { getCalendarEventRepeatLabel } from './get-calendar-event-repeat-label';

export type GetCalendarEventRepeatDisplayOptions = {
  rrule: string | null;
  seriesRrule?: string | null;
  isRecurring?: boolean;
  today: Timestamp;
  t: TranslateFunction;
  weekStartsOn?: WeekDays;
};

export type CalendarEventRepeatDisplay = {
  repeats: boolean;
  isSeriesPatternUnknown: boolean;
  label: string | null;
};

export const getCalendarEventRepeatDisplay = ({
  rrule,
  seriesRrule,
  isRecurring,
  today,
  t,
  weekStartsOn,
}: GetCalendarEventRepeatDisplayOptions): CalendarEventRepeatDisplay => {
  // the master's rule only speaks for an event the series already claims
  const effectiveRrule = rrule ?? (isRecurring ? seriesRrule ?? null : null);

  return {
    repeats: !!rrule || !!isRecurring,
    isSeriesPatternUnknown: !rrule && !!isRecurring,
    label: getCalendarEventRepeatLabel(effectiveRrule, today, t, weekStartsOn),
  };
};
